import React, { memo } from "react";

interface RadialGradientProps {
  id: string;
  duration: number;
  baseColor: string;
}

const RadialGradient = memo(
  ({ id, duration, baseColor }: RadialGradientProps) => {
    const steps = 10;

    const fxSteps = Array.from(
      { length: steps + 1 },
      (_, i) => 50 + Math.cos((i * -2 * Math.PI) / steps) * 50,
    ).map(value => value.toPrecision(1));

    const fySteps = Array.from(
      { length: steps + 1 },
      (_, i) => 50 + Math.sin((i * -2 * Math.PI) / steps) * 50,
    ).map(value => value.toPrecision(1));

    return (
      <radialGradient
        id={id}
        cx={`${fxSteps[0]}%`}
        cy={`${fySteps[0]}%`}
        fx={`${fxSteps[0]}%`}
        fy={`${fySteps[0]}%`}
        style={{ transform: "cx" }}
      >
        <stop offset="5%" stopColor="#05DF54" />
        <stop offset="25%" stopColor="#96C5F0" />
        <stop offset="30%" stopColor="#96C5F0" />
        <stop offset="45%" stopColor={baseColor} />

        {["cx", "cy", "fx", "fy"].map(attr => (
          <animate
            key={`${id}-${attr}`}
            attributeName={attr}
            dur={`${duration}s`}
            repeatCount="indefinite"
            values={
              attr === "cx" || attr === "fx"
                ? fxSteps.map(value => `${value}%`).join(";")
                : fySteps.map(value => `${value}%`).join(";")
            }
          />
        ))}
      </radialGradient>
    );
  },
);

RadialGradient.displayName = "RadialGradient";
export { RadialGradient };
